import React, {Component} from 'react';
import PropTypes from 'prop-types';

import {geoUtils} from '../utils/geo-utils';

class StateSelectorShapes extends Component {

  shouldComponentUpdate(nextProps, nextState) {
    const widthDifferent = nextProps.width !== this.props.width;
    const heightDifferent = nextProps.height !== this.props.height;
    const selectedDifferent = nextProps.selected !== this.props.selected;

    return widthDifferent || heightDifferent || selectedDifferent;
  }

  render() {
    const paths = geoUtils.getMercatorStateCountyPaths(this.props.stateFips, this.props.width, this.props.height);

    return (
      <g className="StateSelectorShapes">
        {paths.map(d => {
          return (
            <path
              key={d.id}
              d={d.path}
              fill={d.id === this.props.selected ? '#00ccff' : '#202020'}
            ></path>
          );
        })}
      </g>
    )
  }
}

StateSelectorShapes.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  stateFips: PropTypes.number,
  selected: PropTypes.number
};


export default StateSelectorShapes


// WEBPACK FOOTER //
// ./src/charts/StateSelector/StateSelectorShapes.js